$(function() {

	function isMobile() {

		var $xs = $('<div class="visible-xs">');
		$('body').append($xs);
		var mobile = $xs.is(':visible');
		$xs.remove();
		return mobile;

	}

	if (!isMobile()) {

		$('.multiselect').each(function() {

			$(this).multiselect({
				enableFiltering:true,
				enableCaseInsensitiveFiltering:true,
				includeSelectAllOption:!$(this).hasClass('multiselect-no-selectall')
			});

		});

	}

});